export default {
    cn: {
        floatingPL: {
            excelName: '客户浮动盈亏统计',
            endOfDayDownload: '下载日结Excel',
            nowDownload: '下载实时Excel',
            placeholder: '日结日期',
            warning: '请先选择一个日结日期',
            tableColumns: [
                { key: 'LOGIN', value: '客户账号', fixed: true },
                { key: 'NAME', value: '客户姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'REGDATE', value: '开户日期' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'ACC_NAME', value: '办事处' },
                { key: 'DEPOSIT', value: '今日客户入金' },
                { key: 'WITHDRAWAL', value: '今日客户出金' },
                { key: 'EQUITY', value: '今日客户净值' },
                { key: 'PREVIOUS_FLOATING_PL', value: '昨日未平仓盈亏' },
                { key: 'FLOATING_PL', value: '今日未平仓盈亏' },
                { key: 'CLOSED_PL', value: '今日平仓盈亏' },
                { key: 'CLOSED_SWAPS', value: '今日平仓利息' },
                { key: 'CLOSED_VOLUME', value: '今日平仓手数' },
                { key: 'ADJUSTMENT', value: '客户调整' },
                { key: 'CLOSED_COMMISSION', value: '今日客户佣金' },
                { key: 'IB_COMMISSION', value: '今日代理自动返佣' },
                { key: 'CL_F_PL', value: '客户浮动盈亏(已扣代理返佣)' },
            ]
        }
    },
    hk: {
        floatingPL: {
            excelName: '客戶浮動盈虧統計',
            endOfDayDownload: '下載日結Excel',
            nowDownload: '下載實時Excel',
            placeholder: '日結日期',
            warning: '請先選擇一個日結日期',
            tableColumns: [
                { key: 'LOGIN', value: '客戶賬號', fixed: true },
                { key: 'NAME', value: '客戶姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'REGDATE', value: '開戶日期' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'ACC_NAME', value: '辦事處' },
                { key: 'DEPOSIT', value: '今日客戶入金' },
                { key: 'WITHDRAWAL', value: '今日客戶出金' },
                { key: 'EQUITY', value: '今日客戶净值' },
                { key: 'PREVIOUS_FLOATING_PL', value: '昨日未平倉盈虧' },
                { key: 'FLOATING_PL', value: '今日未平倉盈虧' },
                { key: 'CLOSED_PL', value: '今日平倉盈虧' },
                { key: 'CLOSED_SWAPS', value: '今日平倉利息' },
                { key: 'CLOSED_VOLUME', value: '今日平倉手數' },
                { key: 'ADJUSTMENT', value: '客戶調整' },
                { key: 'CLOSED_COMMISSION', value: '今日客戶佣金' },
                { key: 'IB_COMMISSION', value: '今日代理自動返佣' },
                { key: 'CL_F_PL', value: '客戶浮動盈虧(已扣代理返佣)' },
            ]
        }
    },
    en: {
        floatingPL: {
            excelName: 'Client floating PL statistics',
            endOfDayDownload: 'Download Daily Excel',
            nowDownload: 'Download Realtime Excel',
            placeholder: 'Daily date',
            warning: 'Please select a daily date',
            tableColumns: [
                { key: 'LOGIN', value: 'Login', fixed: true },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'REGDATE', value: 'Regdate' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'ACC_NAME', value: 'Office Name' },
                { key: 'DEPOSIT', value: 'Deposit' },
                { key: 'WITHDRAWAL', value: 'Withdrawal' },
                { key: 'EQUITY', value: 'Equity' },
                { key: 'PREVIOUS_FLOATING_PL', value: 'Previous Floating PL' },
                { key: 'FLOATING_PL', value: 'Floating PL' },
                { key: 'CLOSED_PL', value: 'Closed PL' },
                { key: 'CLOSED_SWAPS', value: 'Closed Swaps' },
                { key: 'CLOSED_VOLUME', value: 'Closed Volume' },
                { key: 'ADJUSTMENT', value: 'Adjustment' },
                { key: 'CLOSED_COMMISSION', value: 'Commission' },
                { key: 'IB_COMMISSION', value: 'IB Commission' },
                { key: 'CL_F_PL', value: 'Client Floating PL(Without IB Commission)' },
            ]
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/manager-report/floatingPLReport.js